<template>
    <Drawer destroy-on-close :style="{ left: isCollapse ? '54px' : '210px',top: '50px'}" :visible.sync="drawerValue"
        :with-header="false" append-to-body :wrapperClosable="false" direction="rtl" size="100%" :modal="modal" v-bind="$attrs" v-on="$listeners">
        <div class="drawer-component-container flex-column">
            <div class="drawer-header-container flex-center-center" v-if="title || $slots.title">
                <div class="drawer-header-left">
                    <slot name="titleLeft"></slot>
                </div>
                <slot name="title">
                    <div class="drawer-header-middle flex-center-center">{{title}}</div>
                </slot>
                <div class="drawer-header-right">
                    <slot name="titleRight"></slot>
                </div>
                <div class="drawer-close-container" v-if="showClose" @click="handleClose">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="flex-content-scroll">
                <slot></slot>
            </div>
            <div class="drawer-footer-container flex-center-center" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </Drawer>
</template>

<script>
import { Drawer } from 'element-ui';
import { mapGetters } from 'vuex'
export default {
    components: {
      Drawer
    },
    name: 'ElDrawer',
    props: {
      visible: {
        type: Boolean,
        require: true
      },
      title: String,
      showClose: {
        type: Boolean,
        default: true
      },
      modal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      isCollapse() {
        return !this.sidebar.opened
      },
      drawerValue: {
          get() {
              return this.visible
          },
          set(val){
              this.$emit('update:visible',val)
          }
      }
    },
    methods: {
        handleClose() {
            if(this.$attrs.onClose) {
                this.$emit('close');
            }else this.drawerValue = false;
        }
    },
}
</script>
<style scoped lang="scss">
.el-drawer__wrapper {
  transition: left .3s;
}
.drawer-component-container {
    height: 100%;
    background: #f6f8f9;
    padding: 5px;
    box-sizing: border-box;
    position: relative;
    .drawer-header-container {
        position: sticky;
        border-radius: 4px 4px 0 0;
        top: 0;
        width: 100%;
        background: #fff;
        height: 50px;
        box-shadow: 0 2px 12px 0px rgba(0, 0, 0, .1);
        color: #101214;
        font-size: 20px;
        .drawer-header-left {
            font-size: 16px;
            position: absolute;
            left: 15px;
            color: #409EFF;
        }
        .drawer-header-middle {
            font-weight: 600;
        }
        .drawer-header-right {
            font-size: 16px;
            position: absolute;
            right: 60px;
        }
    }
    .drawer-close-container {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-15px);
        font-size: 26px;
        cursor: pointer;
        color: #909399;
    }
    .flex-content-scroll {
        padding: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        background-color: #fff;
    }
    .drawer-footer-container {
        position: sticky;
        bottom: 0;
        width: 100%;
        background: #fff;
        height: 50px;
        box-shadow: 0 0px 12px 2px rgba(0, 0, 0, .1);
        color: #101214;
        border-radius: 0 0 8px 8px;
    }
}
</style>